import React, { Component } from "react";
import TextInputField from "@eres/forms-web/TextInputField";
import Strings from "@my-dld/assets/strings";
import Pagination from "../Pagination";
import CardNoData from "../CardNoData";
import StateHolder from "@eres/forms/StateHolder";

export const GRID_SIZE = 12;

interface Props<T> {
	title?: string;
	items: T[];
	onSearch?: ( searchKey?: string ) => void;
	renderGridItem: ( item: T, index: number ) => React.ReactElement;
	totalCount?: number;
	onPageChange?: ( page: number ) => void;
	searchQuery?: string;
}

interface State {
	searchKey?: string;
}

class GridDataView<T> extends Component<Props<T>, State> {
	constructor( props: Props<T> ) {
		super( props );
		this.state = {searchKey: props.searchQuery};
	}

	render() {
		const { title, items, renderGridItem, onSearch, totalCount, onPageChange } = this.props;
		return <React.Fragment>
			{ onSearch && <RenderSearch
				cmp={ this } title={ title }
				onSearch={ onSearch }/> }
			{ items.length > 0 && <React.Fragment>
				<div className="row">
					{ items.map( ( item: T, index: number ) => {
						return renderGridItem( item, index );
					} ) }
				</div>
				{ totalCount !== undefined && onPageChange &&
					<RenderPagination
						totalCount={ totalCount ? totalCount : 0 }
						onPageChange={ onPageChange }/> }
			</React.Fragment> }
			{ items.length === 0 && <CardNoData containerClass="alert alert-warning"/> }
		</React.Fragment>;
	}
}

export function RenderSearch( props: { cmp: Component, onSearch?: ( searchKey?: string ) => void, title?: string } ) {
	const { title, onSearch, cmp } = props;
	const holder = StateHolder.buildStateHolder( cmp );
    const searchClass = title ? "col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12" : "col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12";
	return <div className="row page-function">
		{ title && <div className="col-xl-8 col-lg-6 col-md-6 col-sm-4 col-4 hide">
			<span className="proeprty-page-sub-title">{ title }</span>
		</div> }
		<div className={ searchClass }>
            <div className="position-relative w-100">
					<TextInputField
                    id={"searchKey"}
                    label={Strings.search}
                    labelClassName="sr-only"
                    holder={holder}
                    containerClassName="search-field-icon"
                    inputClassName="form-control search-field-icon"
				    placeHolder={ Strings.search }
				    onValueChange={ ( value ) => {
				    	if ( onSearch )
                            onSearch(value);
                    }} children={<><button className="btn txt-clear-btn" type="button"><i className="material-icons-outlined">close</i></button></>} />

			</div>
		</div>
	</div>;
}

export function RenderPagination( props: { totalCount: number, onPageChange: ( page: number ) => void; pageSize?: number } ) {
	const { totalCount, onPageChange, pageSize = GRID_SIZE } = props;
	return <Pagination
		containerClass="pagination-static-table"
		totalCount={ totalCount }
		pageSize={ pageSize }
		onChangePage={ onPageChange }/>;
}

export default GridDataView;
